import type { VaultKind } from '@onefootprint/request-types/dashboard';
import constate from 'constate';

type UseEntityContext = {
  kind: VaultKind;
  listPath: string;
};

const useEntity = (options: UseEntityContext) => options;

const [Provider, useEntityContext] = constate(useEntity);

export default Provider;
export { useEntityContext };
